import supplier from './../../../services/purchase/supplier';
import supplierSearch from './supplierSearch';
import supplierList from './supplierList'

export default {
    namespaced: true,
    modules:{
        supplierSearch,
        list: supplierList
    },
    state: {
    },
    getters: {
    },
    mutations: {
        setLoading: (state, payload) => state.loading = payload,
    },
    actions: {
        find(context, payload) {
            return new Promise((resolve, reject) => {
                supplier.find(payload).then(response => {
                    resolve(response)
                }).catch(error => reject(error));
            });
        },
        create(context, payload) {
            return new Promise((resolve, reject) => {
                supplier.create(payload).then(response => {
                    resolve(response)
                }).catch(error => reject(error));
            });
        },
        update(context, payload) {
            return new Promise((resolve, reject) => {
                supplier.update(payload).then(response => {
                    resolve(response)
                }).catch(error => reject(error));
            });
        },
        remove(context, payload) {
            return new Promise((resolve, reject) => {
                supplier.remove(payload).then(response => {
                    resolve(response)
                })
                .catch(error => reject(error))
                .finally(() =>  context.commit("setLoading", true))
            });
        }
    }
}